import styles from "./styles.module.scss";
import React, { FunctionComponent, useEffect, useState } from "react";
import { Card, CardActionArea, IconButton, Stack, Tooltip, useTheme } from "@mui/material";
import { useGetImage } from "../../../../hooks/images";
import { StatusCodesHelper } from "../../../../models/StatusCodesHelper";
import { ImageCache } from "../../../../models/ImageCache";
import { LazyImageAspectFit } from "../../../LazyImageAspectFit";
import { strings } from "../../../../localization/LocalizedStrings";
import { Icon, IconType } from "../../../../icons";
import { IGearItem } from "../../../../hooks/gearItems";

export const GearItemCard: FunctionComponent<IGearItemCardProps> = ({
  gearItem,
  selected,
  onClick,
  onContextMenu
}) => {
  const theme = useTheme();
  const { getImage } = useGetImage();
  const [image, setImage] = useState();
  const [imageUpdateCount, setImageUpdateCount] = useState(0);
  const genericImage = new URL("../../../../images/generic_label.png", import.meta.url).href;
  const fetchImage = async () => {
    if (!gearItem.hasImage) return;
    const response = await getImage({
      name: gearItem.uuid,
      width: ImageCache.bigLabelImageSize,
      height: ImageCache.bigLabelImageSize
    });
    if (StatusCodesHelper.isSuccessful(response.status)) {
      setImage(response.body);
    }
  };
  useEffect(() => {
    if (imageUpdateCount > 0) {
      setImage(undefined);
      fetchImage().then();
    } else {
      setImageUpdateCount(state => state + 1);
    }
  }, [gearItem]);
  return (
    <Card className={styles.container} sx={{ height: 80 }} elevation={5}>
      <CardActionArea
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "row"
        }}
        style={{
          borderColor: theme.palette.colors?.highlightBorder,
          borderWidth: 4,
          borderStyle: selected ? "double" : "none"
        }}
        onContextMenu={event => onContextMenu(event, image)}
        onClick={event => onClick(event, image)}
      >
        <Stack alignItems={"center"}>
          {gearItem.hasImage ? (
            <LazyImageAspectFit
              className={styles.image}
              imageStyle={{ borderRadius: "16px" }}
              image={image}
              thumbnail={gearItem.thumbnail}
              defaultImage={genericImage}
              beforeLoad={fetchImage}
              alt={gearItem.name}
            />
          ) : (
            <Card className={styles.defaultIcon}>
              <Icon type={IconType.AudioVideoReceiver} />
            </Card>
          )}
          {gearItem.status === "inactive" && (
            <Card style={{ marginTop: -2, backgroundColor: theme.palette.colors.goldmineGray }}>
              <p className={styles.inactiveCard}>{strings.status_inactive}</p>
            </Card>
          )}
        </Stack>
        <Stack className={styles.rightContainer}>
          <p className={styles.name}>{gearItem.name}</p>
          <p className={styles.brand}>{gearItem.brand}</p>
          <p className={styles.profile}>{gearItem.description}</p>
        </Stack>
      </CardActionArea>
      <Stack className={styles.hoverButtonsStack} direction={"row"} spacing={1}>
        <Tooltip title={strings.options} arrow disableInteractive>
          <IconButton
            className={styles.hoverButton}
            style={{ backgroundColor: theme.palette.colors?.counterBackground }}
            onClick={event => onContextMenu(event, image)}
          >
            <Icon type={IconType.MoreVertical} />
          </IconButton>
        </Tooltip>
      </Stack>
    </Card>
  );
};

export interface IGearItemCardProps {
  gearItem: IGearItem;
  selected?: boolean;
  onClick: (event: React.MouseEvent, imageData?: string) => void;
  onContextMenu: (event: React.MouseEvent, imageData?: string) => void;
}
